import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const normalizeMessages = (messages) => {
  if (!Array.isArray(messages)) {
    return [];
  }

  return messages
    .filter((message) => typeof message === 'string')
    .map((message) => message.trim())
    .filter((message) => message !== '');
};

const HelpDialog = ({ isOpen, title, messages, onClose }) => {
  const pages = useMemo(() => normalizeMessages(messages), [messages]);
  const [currentPage, setCurrentPage] = useState(0);
  const isPaginationVisible = pages.length > 1;

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    setCurrentPage(0);
  }, [isOpen, messages]);

  if (!pages.length) {
    return null;
  }

  return (
    <BaseDialog isVisible={isOpen} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          minWidth: 'min(70vw, 560px)',
        }}
      >
        <Typography variant="subtitle1" sx={{ color: '#111', fontWeight: 600 }}>{title}</Typography>
        <Typography component="div" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, color: '#111', minHeight: '7em' }}>
          {pages[currentPage]}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {isPaginationVisible ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                variant="outlined"
                onClick={() => setCurrentPage((prev) => prev - 1)}
                disabled={currentPage === 0}
              >
                前へ
              </Button>
              <Typography sx={{ color: '#555', minWidth: '5em', textAlign: 'center' }}>
                {currentPage + 1} / {pages.length}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={currentPage === pages.length - 1}
              >
                次へ
              </Button>
            </Box>
          ) : <Box />}
          <Button variant="contained" onClick={onClose}>
            閉じる
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};

export default HelpDialog;
